import React, { useState, useEffect } from "react";
import propTypes from "prop-types";
import { useFormContext } from "./Form";
import Select from "./Select";
import useField, { getScopedName, fieldPropTypes } from "./field";

import ReactSelect, { Async } from "react-select";

const ComboBox = ({
    async = false,
    inputProps = {},
    valueKey = "id",
    labelKey = "value",
    options = [],
    fallbackProps = {},
    ...props
}) => {

    const [upgraded, setUpgraded] = useState(async);

    useEffect(() => {
        setUpgraded(true);
    }, []);

    const context = useFormContext();
    const {
        id,
        key,
        name,
        errors,
        value,
        fieldProps,
        handleValidation,
    } = useField(props, context, ["name", "value", "onChange", "onInvalid"]);

    if (!upgraded) {
        return (<Select {...props} {...fallbackProps}>
            <option hidden key="" value="">{props.placeholder || "Select"}</option>
            {options.map((option) => (
                <option key={option[valueKey]} value={option[valueKey]}>
                    {option[labelKey]}
                </option>
            ))}
        </Select>);
    }

    const SelectTag = async ? Async : ReactSelect;
    const controlName = getScopedName(`${props.name}--control`, context);
    const inputId = `${id}--input`;

    const handleChange = function (e) {
        const key = (e && e.hasOwnProperty(valueKey)
            ? e[valueKey]
            : (e || ""));

        context.form.setValue(name, key);

        if (context.form.revising) {
            const input = document.getElementById(inputId);
            const errors = context.form.validateField(input);

            context.form.setErrors(input.name, errors);
        }

        if (props.onChange) {
            props.onChange(e);
        }
    };

    // Add the invalid handler to the passed-in input props.
    inputProps.onInvalid = handleValidation;

    return [
        <input
            key={key}
            id={inputId}
            type="hidden"
            name={name}
            value={
                (value && value.hasOwnProperty(valueKey))
                    ? value[valueKey]
                    : value
            }
        />,
        <SelectTag
            key={`${key}--control`}
            name={controlName}
            value={value}
            onChange={handleChange}
            inputProps={inputProps}
            instanceId={fieldProps.id}
            labelKey={labelKey}
            valueKey={valueKey}
            options={options}
            {...fieldProps}
        />,
        ...errors.elements,
    ];
};

ComboBox.propTypes = {
    ...fieldPropTypes,
    inputProps: propTypes.object,
    async: propTypes.bool,
};

export default ComboBox;
